"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("./types");
class LocalStorage {
    constructor() {
        this.storage = window.localStorage;
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    close() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    get(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const val = this.storage.getItem(key);
            if (val === null) {
                throw types_1.ErrKeyNotFound;
            }
            return val;
        });
    }
    set(key, val) {
        return __awaiter(this, void 0, void 0, function* () {
            this.storage.setItem(key, val);
        });
    }
    getOrSet(key, genFn) {
        return __awaiter(this, void 0, void 0, function* () {
            let val = this.storage.getItem(key);
            if (val === null) {
                val = genFn();
                this.storage.setItem(key, val);
            }
            return val;
        });
    }
}
exports.LocalStorage = LocalStorage;
//# sourceMappingURL=storage.js.map